import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { includes } from 'lodash'
import classnames from 'classnames/bind'
import { Icon, CheckboxField, Grid } from '@adc/ui-adc'
import { formatDate, formatAuctionDateTime } from '../../utils/date'
import VenueDetails from './venueDetails'
import styles from './styles.scss'

const { Row, Column } = Grid
const cx = classnames.bind(styles)

const VenuesMobileTable = ({
  elmId,
  venues,
  isOnline,
  onChangeVenues,
  openDetails = {},
  onToggleDetails,
  selected = [],
  filteredDate,
}) => {
  const isSelectedVenue = venueId => includes(selected, venueId)

  const toggleVenue = venueId => {
    const idsList = [...selected]
    const idIndex = idsList.indexOf(venueId)
    if (idIndex >= 0) {
      idsList.splice(idIndex, 1)
    } else {
      idsList.push(venueId)
    }
    onChangeVenues(idsList)
  }

  const renderLiveRows = (id, venueList) =>
    venueList.map((venue, index) => {
      const expandedIcon = openDetails[venue.venue_id]
        ? 'angle-up'
        : 'angle-down'

      return (
        <Row collapsed={{ small: true }} key={venue.venue_id}>
          <Column mobile={1}>
            <CheckboxField
              elmId={`${id}_venue_${venue.venue_id}_${index}_checkbox_mobile`}
              checked={isSelectedVenue(venue.venue_id)}
              onChange={() => toggleVenue(venue.venue_id)}
            />
          </Column>
          <Column mobile={15}>
            <div
              className={cx('mobile-label')}
              data-elm-id={`${id}_venue_${venue.venue_id}_${index}_header1_mobile`}
            >
              Location
            </div>
            <div
              data-elm-id={`${id}_venue_${venue.venue_id}_${index}_name_mobile`}
            >
              {venue.venue_name}
            </div>
            <div
              className={cx('mobile-label', 'upper-space')}
              data-elm-id={`${id}_venue_${venue.venue_id}_${index}_header2_mobile`}
            >
              Auction Date
            </div>
            <div
              data-elm-id={`${id}_venue_${venue.venue_id}_${index}_auction_date_mobile`}
            >
              {formatDate(
                venue.venue_schedule.bid_start_local_date,
                'MMM DD, YYYY'
              )}
            </div>
            <div
              className={cx('mobile-expand-icon')}
              data-elm-id={`${id}_venue_${venue.venue_id}_${index}_expand_mobile`}
              onClick={() => onToggleDetails(venue.venue_id)}
            >
              <Icon name={expandedIcon} iconStyle='regular' />
            </div>
          </Column>
          {openDetails[venue.venue_id] && (
            <Column className={cx('mobile-details')} mobile={16}>
              <VenueDetails
                elmId={`${id}_venue_${venue.venue_id}_${index}`}
                venue={venue}
                isMobile
              />
            </Column>
          )}
          <Column mobile={16}>
            <div className={cx('divider')} />
          </Column>
        </Row>
      )
    })

  const renderOnlineRows = (id, venueList) =>
    venueList.map((venue, index) => (
      <Row collapsed={{ small: true }} key={venue.venue_id}>
        <Column mobile={1}>
          <CheckboxField
            elmId={`${id}_venue_${venue.venue_id}_${index}_checkbox_mobile`}
            checked={isSelectedVenue(venue.venue_id)}
            onChange={() => toggleVenue(venue.venue_id)}
          />
        </Column>
        <Column mobile={15}>
          <div
            className={cx('mobile-label')}
            data-elm-id={`${id}_venue_${venue.venue_id}_${index}_header1_mobile`}
          >
            Location
          </div>
          <div
            data-elm-id={`${id}_venue_${venue.venue_id}_${index}_name_mobile`}
          >
            {venue.venue_name}
          </div>
          <div
            className={cx('mobile-label', 'upper-space')}
            data-elm-id={`${id}_venue_${venue.venue_id}_${index}_header2_mobile`}
          >
            Auction Starts
          </div>
          <div
            data-elm-id={`${id}_venue_${venue.venue_id}_${index}_auction_start_mobile`}
          >
            {formatAuctionDateTime(
              moment(
                `${venue.venue_schedule.bid_start_local_date} ${venue.venue_schedule.bid_start_local_time}`
              ),
              moment(
                `${venue.venue_schedule.initial_bidding_end_local_date} ${venue.venue_schedule.initial_bidding_end_local_time}`
              ),
              true
            )}
          </div>
          <div
            className={cx('mobile-label', 'upper-space')}
            data-elm-id={`${id}_venue_${venue.venue_id}_${index}_header3_mobile`}
          >
            Auction Ends
          </div>
          <div
            data-elm-id={`${id}_venue_${venue.venue_id}_${index}_auction_end_mobile`}
          >
            {formatAuctionDateTime(
              moment(
                `${venue.venue_schedule.bid_start_local_date} ${venue.venue_schedule.bid_start_local_time}`
              ),
              moment(
                `${venue.venue_schedule.initial_bidding_end_local_date} ${venue.venue_schedule.initial_bidding_end_local_time}`
              ),
              false
            )}
          </div>
        </Column>
      </Row>
    ))

  if (!venues || venues.length === 0) {
    return null
  }

  const filteredVenues = filteredDate
    ? venues.filter(
        venue => venue.venue_schedule.bid_start_local_date === filteredDate
      )
    : venues

  const venueRows = isOnline
    ? renderOnlineRows(elmId, filteredVenues)
    : renderLiveRows(elmId, filteredVenues)

  return (
    <div className={cx('venues-table-mobile')}>
      <Grid>{venueRows}</Grid>
    </div>
  )
}

VenuesMobileTable.propTypes = {
  elmId: PropTypes.string.isRequired,
  venues: PropTypes.array.isRequired,
  isOnline: PropTypes.bool.isRequired,
  onChangeVenues: PropTypes.func.isRequired,
  openDetails: PropTypes.object,
  onToggleDetails: PropTypes.func.isRequired,
  selected: PropTypes.array,
  filteredDate: PropTypes.string,
}

export default VenuesMobileTable
